import { Card, Box, CardHeader } from '@mui/material';
import { width } from '@mui/system';
import React from 'react'
import Typography from 'views/utilities/Typography';

export default function ShadowBox(props) {

    const { shadow, header, content } = props;

    return (
        <Card sx={{ mb: 2, boxShadow: shadow, width: '100%' }}>
            {header ? <CardHeader title={header} sx={{py: 1}} /> : ''}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: 1,
                    bgcolor: 'secondary.light',
                    color: 'grey.800'
                }}
            >
                <Box sx={{ color: 'inherit', width: '98%' }}>
                    {content}
                </Box>
            </Box>
        </Card>
    )
}
